import { Detection } from "@/store/detection-slice";
import { DroneMarker } from "../drone-marker";
import { useMap } from "react-map-gl/maplibre";
import { useStore } from "@/store/store";
type Props = {
  detections?: Detection[];
};
export const DetectionLayer = ({ detections }: Props) => {
  const map = useMap();

  const trackedDroneId = useStore(state => state.trackedDroneId)

  const store = useStore()

  const handleDroneClick = (drone: Detection) => {

    if (trackedDroneId === null || trackedDroneId !== drone.drone_identifier) {
      store.setTrackedDroneId(drone.drone_identifier)
      map.current?.flyTo({
        center: [drone.longitude, drone.latitude],
        zoom: 14,
      });
    } else {
      store.setTrackedDroneId(null)
    }

   
  };

  return (
    <>
      {detections?.map((detection, i) => (
        <DroneMarker
          key={i}
          latitude={detection.latitude}
          longitude={detection.longitude}
          drone={detection}
          action={() => handleDroneClick(detection)}
        />
      ))}
      
      {/* Draw a line to plot the path of the drone */}
    </>
  );
};
